export default "__VITE_ASSET__D1s4SGdB__"